"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var effectsPlugin = {
    expose: {
        effects: {},
    },
    init: function (_a) {
        var effects = _a.effects, dispatch = _a.dispatch, createDispatcher = _a.createDispatcher, validate = _a.validate;
        return ({
            onModel: function (model) {
                Object.keys(model.effects || {}).forEach(function (effectName) {
                    validate([
                        [
                            !!effectName.match(/\//),
                            "Invalid effect name (" + model.name + "/" + effectName + ")",
                        ],
                        [
                            typeof model.effects[effectName] !== 'function',
                            "Invalid effect (" + model.name + "/" + effectName + "). Must be a function",
                        ],
                    ]);
                    effects[model.name + "/" + effectName] = model.effects[effectName].bind(dispatch[model.name]);
                    // add effect to dispatch
                    // is assuming dispatch is available already... that the dispatch plugin is in there
                    dispatch[model.name][effectName] = createDispatcher(model.name, effectName);
                    // tag effects so they can be differentiated from normal actions
                    dispatch[model.name][effectName].isEffect = true;
                });
            },
            middleware: function (store) { return function (next) { return function (action) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(action.type in effects)) return [3 /*break*/, 3];
                            return [4 /*yield*/, next(action)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, effects[action.type](action.payload, store.getState(), action.meta)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3: return [2 /*return*/, next(action)];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }; }; },
        });
    },
};
exports.default = effectsPlugin;
//# sourceMappingURL=effects.js.map